<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-dialog customerEDIInfo"
    :style="$cookies.get('comp-id') === $cookies.get('ownr-id') ? 'width: 520px !important;' : ''"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title
        >{{ options.item.action }} Converter</v-card-title
      >
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="v-dialog-1 dialog-partner-detail">
      <!-- [S]  Popup body-->
      <v-card-text class="pa-0 mb-0 pt-2">
        <v-row>
          <v-col cols="12">
            <v-form
              ref="form"
              class="dialog-content form-identification mb-1"
              style="height: 700px; overflow: auto"
            >
              <v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="px-3 py-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.converters.converterName') }}
                  </v-label>
                  <v-text-field
                    ref="cvtrNm"
                    v-model="formData.cvtrNm"
                    :rules="[validationUtils.required]"
                    :disabled="!$auth.manage || options.item.action == 'Edit'"
                    heigth="30"
                    solo
                    @blur="validateConverterName()"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-for="(converter, index) in listConverter"
                  :key="index"
                  cols="12"
                  md="12"
                  class="px-3 py-1"
                >
                  <div class="d-flex justify-between align-center mb-1">
                    <v-label>
                      <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                      {{ $t('lbl.converters.page_header') }} # {{ index + 1 }}
                    </v-label>
                    <div class="d-flex">
                      <span style="cursor: pointer;" @click="handleAddConverter(index)">
                        <icon-svg iconName="add-conv" />
                      </span>
                      <span style="cursor: pointer;" @click="handleRemoveConverter(index)">
                        <icon-svg
                          v-if="index > 0 || listConverter.length > 1"
                          class="ml-1"
                          iconName="remove-conv"
                        />
                      </span>
                    </div>
                  </div>
                  <v-row class="px-2 ma-0" style="border: 1px solid #C5D1E3; border-radius: 4px;">
                    <v-col cols="12" md="12" class="px-4 py-0 mt-4">
                      <v-select
                        v-model="converter.cvtrTpCd"
                        :items="cvtrTpCdList"
                        :rules="[validationUtils.required]"
                        solo
                        :menu-props="{ offsetY: true }"
                        :disabled="!$auth.manage"
                        @change="
                          selectConverterType(index);
                          checkChangeConverter(index);
                        "
                      ></v-select>
                    </v-col>
                    <v-col
                      v-if="
                        converter.cvtrTpCd === 'FILECONTENT_REPLACER' ||
                          converter.cvtrTpCd === 'FILENAME_CAPTOR' ||
                          converter.cvtrTpCd === 'FILECONTENT_CAPTOR' ||
                          converter.cvtrTpCd === 'API_CAPTOR' ||
                          converter.cvtrTpCd === 'FILENAME_REPLACER' ||
                          converter.cvtrTpCd === 'SHINE_CAPTOR'
                      "
                      cols="12"
                      md="12"
                      class="px-3 py-0"
                    >
                      <v-label>
                        <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                        {{ converter.cvtrTpCd === 'API_CAPTOR' ? 'API URI' : 'Search pattern' }}
                      </v-label>
                      <v-text-field
                        v-model="converter.srcPttn"
                        ref="srcPttn"
                        :disabled="!$auth.manage"
                        :rules="[validationUtils.required]"
                        solo
                        @keyup="checkChangeConverter(index)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="
                        converter.cvtrTpCd === 'FILENAME_REPLACER' ||
                          converter.cvtrTpCd === 'FILECONTENT_REPLACER' ||
                          converter.cvtrTpCd === 'SHINE_CAPTOR'
                      "
                      cols="12"
                      md="12"
                      class="px-3 py-0 flex justify-between"
                    >
                      <v-label>
                        <v-icon
                          x-small
                          class="mr-1"
                          v-if="converter.cvtrTpCd !== 'FILECONTENT_REPLACER'"
                          >fa fa-asterisk</v-icon
                        >
                        {{ $t('lbl.converters.replacePttn') }}
                      </v-label>
                    </v-col>
                    <v-col
                      v-if="
                        converter.cvtrTpCd === 'FILENAME_REPLACER' ||
                          converter.cvtrTpCd === 'FILECONTENT_REPLACER' ||
                          converter.cvtrTpCd === 'SHINE_CAPTOR'
                      "
                      cols="12"
                      md="12"
                      class="px-3 py-0"
                    >
                      <v-text-field
                        v-model="converter.repPttn"
                        :disabled="!$auth.manage"
                        v-bind="
                          converter.cvtrTpCd !== 'FILECONTENT_REPLACER'
                            ? { rules: [validationUtils.required] }
                            : {}
                        "
                        solo
                        @keyup="checkChangeConverter(index)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="converter.cvtrTpCd === 'FILENAME_REDUCER'"
                      cols="12"
                      md="12"
                      class="px-3 py-0"
                    >
                      <v-label>
                        <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                        {{ $t('lbl.converters.maxFileName') }}
                      </v-label>
                      <v-text-field
                        v-model="converter.nmMaxLen"
                        :disabled="!$auth.manage"
                        :rules="[validationUtils.required]"
                        solo
                        @keyup="checkChangeConverter(index)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="converter.cvtrTpCd === 'FILENAME_REDUCER'"
                      cols="12"
                      md="12"
                      class="px-3 py-0"
                    >
                      <v-label>
                        <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                        {{ $t('lbl.converters.cutFileName') }}
                      </v-label>
                      <v-select
                        v-model="converter.nmCutTp"
                        :items="cutTypeList"
                        :rules="[validationUtils.required]"
                        solo
                        :disabled="!$auth.manage"
                        :menu-props="{ offsetY: true }"
                        @change="checkChangeConverter(index)"
                      ></v-select>
                    </v-col>
                    <v-col
                      v-if="
                        converter.cvtrTpCd === 'FILECONTENT_REPLACER' ||
                          converter.cvtrTpCd === 'FILECONTENT_CAPTOR'
                      "
                      cols="12"
                      md="12"
                      class="px-3 py-0"
                    >
                      <v-label>
                        {{ $t('lbl.converters.numSkip') }}
                      </v-label>
                      <v-text-field
                        v-model="converter.skipLineCnt"
                        :disabled="!$auth.manage"
                        solo
                        @keyup="checkChangeConverter(index)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="
                        converter.cvtrTpCd === 'FILECONTENT_REPLACER' ||
                          converter.cvtrTpCd === 'FILECONTENT_CAPTOR'
                      "
                      cols="12"
                      md="12"
                      class="px-3 py-0"
                    >
                      <v-label>
                        {{ $t('lbl.converters.numRepeat') }}
                      </v-label>
                      <v-text-field
                        v-model="converter.reptLineCnt"
                        :disabled="!$auth.manage"
                        solo
                        @keyup="checkChangeConverter(index)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="
                        converter.cvtrTpCd === 'FILE_ENVELOPER' ||
                          converter.cvtrTpCd === 'FILE_DEENVELOPER'
                      "
                      cols="12"
                      md="12"
                      class="px-3 py-0"
                    >
                      <v-label>
                        {{
                          converter.cvtrTpCd === 'FILE_ENVELOPER'
                            ? 'Envelope header'
                            : 'Deenvelope header'
                        }}
                      </v-label>
                      <v-text-field
                        v-model="converter.envHdr"
                        :disabled="!$auth.manage"
                        solo
                        @keyup="checkChangeConverter(index)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="
                        converter.cvtrTpCd === 'FILE_ENVELOPER' ||
                          converter.cvtrTpCd === 'FILE_DEENVELOPER'
                      "
                      cols="12"
                      md="12"
                      class="px-3 py-0"
                    >
                      <v-label>{{
                        converter.cvtrTpCd === 'FILE_ENVELOPER'
                          ? 'Envelope footer'
                          : 'Deenvelope footer'
                      }}</v-label>
                      <v-text-field
                        v-model="converter.envFtr"
                        :disabled="!$auth.manage"
                        solo
                        @keyup="checkChangeConverter(index)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="converter.cvtrTpCd === 'FILE_DEENVELOPER'"
                      cols="12"
                      md="12"
                      class="px-3 py-0"
                    >
                      <v-label>{{ $t('lbl.converters.splitPttn') }}</v-label>
                      <v-text-field
                        v-model="converter.spltPttn"
                        :disabled="!$auth.manage"
                        solo
                        @keyup="checkChangeConverter(index)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="converter.cvtrTpCd === 'DB_CAPTOR'"
                      cols="12"
                      md="12"
                      class="px-3 py-0"
                    >
                      <v-label>
                        <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                        {{ $t('lbl.converters.dbBroker') }}
                      </v-label>
                      <v-autocomplete
                        v-model="converter.dBBroker"
                        :rules="[validationUtils.required]"
                        :items="dbBrkList"
                        :disabled="!$auth.manage"
                        solo
                        @change="checkChangeConverter(index)"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      v-if="
                        converter.cvtrTpCd === 'USERDATA_CAPTOR' ||
                          converter.cvtrTpCd === 'FILENAME_CAPTOR' ||
                          converter.cvtrTpCd === 'FILECONTENT_CAPTOR' ||
                          converter.cvtrTpCd === 'API_CAPTOR' ||
                          converter.cvtrTpCd === 'DB_CAPTOR'
                      "
                      cols="12"
                      md="5"
                      class="pl-3 pr-0 py-0"
                    >
                      <v-label
                        v-if="
                          converter.cvtrTpCd !== 'API_CAPTOR' && converter.cvtrTpCd !== 'DB_CAPTOR'
                        "
                      >
                        <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                        {{ $t('lbl.processSetup.converter_data_user') }}
                      </v-label>
                      <v-label v-else>{{ $t('lbl.processSetup.converter_data_user') }}</v-label>
                    </v-col>
                    <v-col
                      v-if="
                        converter.cvtrTpCd === 'USERDATA_CAPTOR' ||
                          converter.cvtrTpCd === 'FILENAME_CAPTOR' ||
                          converter.cvtrTpCd === 'FILECONTENT_CAPTOR' ||
                          converter.cvtrTpCd === 'API_CAPTOR' ||
                          converter.cvtrTpCd === 'DB_CAPTOR'
                      "
                      cols="12"
                      md="7"
                      class=" pl-0 py-0 text-left"
                    >
                      <v-icon @click="addCaptor(index)" :disabled="!$auth.manage" dense dark
                        >mdi-plus</v-icon
                      >
                    </v-col>
                    <v-col
                      v-if="
                        converter.cvtrTpCd === 'USERDATA_CAPTOR' ||
                          converter.cvtrTpCd === 'FILENAME_CAPTOR' ||
                          converter.cvtrTpCd === 'FILECONTENT_CAPTOR' ||
                          converter.cvtrTpCd === 'API_CAPTOR' ||
                          converter.cvtrTpCd === 'DB_CAPTOR'
                      "
                      cols="12"
                      md="12"
                      class="px-3 pb-4 pt-0"
                    >
                      <v-row
                        class="pt-0 pt-0 pb-1 edi-identification-right"
                        v-for="(item, i) in converter.listUserData"
                        :key="item.id"
                      >
                        <v-col lg="4" class="pl-3 pr-2 py-0">
                          <v-text-field
                            :ref="'CAPTOR_' + index + '_' + item.id"
                            :maxlength="50"
                            solo
                            hide-details
                            placeholder="Key"
                            :disabled="!$auth.manage"
                            v-model="item.key"
                            @keyup="checkChangeConverter(index)"
                          ></v-text-field>
                        </v-col>
                        <v-col lg="7" class="pl-2 pr-2 py-0">
                          <v-text-field
                            :ref="'CAPTOR_' + index + '_' + item.id + '_' + item.id"
                            :maxlength="50"
                            solo
                            hide-details
                            placeholder="Value"
                            :disabled="!$auth.manage"
                            v-model="item.value"
                            @keyup="checkChangeConverter(index)"
                          ></v-text-field>
                        </v-col>
                        <v-col lg="1" class="pa-0 pr-3 mr-0 mt-2">
                          <v-icon
                            @click="removeCaptor(index, i)"
                            :disabled="!$auth.manage"
                            dense
                            class="ml-1"
                            dark
                            >mdi-minus</v-icon
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col cvtr-custom" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
                {{ $t('lbl.converters.close') }}
              </v-btn>
              <v-btn
                class="btn btn-popup-search btn-popup"
                color="primary"
                @click="onSave"
                :disabled="!$auth.manage"
              >
                {{ $t('lbl.converters.save') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->
      <dialogWindow
        ref="warningDialog"
        size="max"
        title="Merge & Compare"
        :detail="add_valid_str"
        color="warning"
      ></dialogWindow>
      <dialogWindow
        ref="errorDialog"
        size="max"
        title="Merge & Compare"
        :detail="add_valid_str"
        color="error"
      ></dialogWindow>
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag2.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapState } from 'vuex';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { showProgress, hideProgress } from '@/vue-dlb/utils/sys-util.js';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  name: 'add-parner-dialog',
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd'],
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    companyId: String,
    cvtrTpCdList: Array,
    refeshList: Function,
  },
  computed: {
    converterList() {
      return this.$store.getters.converterSelectBoxList;
    },
  },
  data() {
    return {
      add_valid_str: '',
      listConverter: [
        {
          cvtrId: '',
          seq: 0,
          cvtrTpCd: 'FILENAME_REPLACER',
          srcPttn: '',
          repPttn: '',
          nmMaxLen: '',
          nmCutTp: '',
          skipLineCnt: '',
          reptLineCnt: '',
          envHdr: '',
          envFtr: '',
          spltPttn: '',
          dBBroker: '',
          listUserData: [],
          flag: 'I',
        },
      ],
      formData: {
        cvtrId: '',
        cvtrNm: '',
      },
      dbBrkList: [],
      dBBroker: '',
      listUserData: [],
      deleteSubList: [],
      cutTypeList: [
        { value: '0', text: 'Cut From Left' },
        { value: '1', text: 'Cut From Right (with out extension)' },
        { value: '2', text: 'Cut From Rigth (with extension)' },
      ],
    };
  },

  watch: {},

  methods: {
    validateConverterName() {
      const isDuplicate = this.converterList.some(
        (e) => e.cvtrNm === this.formData.cvtrNm && e.cvtrId !== this.formData.cvtrId
      );
      if (isDuplicate) {
        this.add_valid_str = `Converter name : ${this.formData.cvtrNm} have been created !`;
        this.formData.cvtrNm = '';
        this.$refs.warningDialog.dialog = true;
        return false;
      }
      return true;
    },
    checkChangeConverter(index) {
      let converter = this.listConverter[index];
      if (converter.cvtrId) {
        converter.flag = 'U';
        this.listConverter.splice(index, 1, converter);
      }
    },
    handleAddConverter(index) {
      for (let i = 0; i < this.listConverter.length; i++) {
        let converter = this.listConverter[i];
        if (converter.seq > index) {
          converter.oldSeq = converter.oldSeq ? converter.oldSeq : converter.seq;
          converter.seq += 1;
          if (converter.cvtrId) converter.flag = 'U';
          this.listConverter.splice(i, 1, converter);
        }
      }
      const converter = {
        cvtrTpCd: 'FILENAME_REPLACER',
        seq: index + 1,
        srcPttn: '',
        repPttn: '',
        nmMaxLen: '',
        nmCutTp: '',
        skipLineCnt: '',
        reptLineCnt: '',
        envHdr: '',
        envFtr: '',
        spltPttn: '',
        flag: 'I',
      };
      this.listConverter.splice(index + 1, 0, converter);
    },
    handleRemoveConverter(index) {
      for (let i = 0; i < this.listConverter.length; i++) {
        let converter = this.listConverter[i];
        if (converter.seq > index) {
          converter.oldSeq = converter.oldSeq ? converter.oldSeq : converter.seq;
          converter.seq -= 1;
          if (converter.cvtrId) converter.flag = 'U';
          this.listConverter.splice(i, 1, converter);
        }
      }
      if (this.listConverter[index].cvtrId) this.deleteSubList.push(this.listConverter[index]);
      this.listConverter.splice(index, 1);
    },
    async initialize() {
      this.$store.dispatch('getCvtrGrpList');

      this.$store.dispatch('getDbBrokerList').then((res) => {
        res.map((e) => {
          this.dbBrkList.push({ text: e.DBBRK_NM, value: e.DBBRK_ID });
        });
      });
      if (this.options.item.action != 'Add') {
        this.formData = this.options.item.data;
        let listData = [];
        await this.$store
          .dispatch('getConverterDetail', this.options.item.data.cvtrId)
          .then(() => {
            listData = this.$store.getters.converterDetail;
          })
          .catch((ex) => {});
        for (let i = 0; i < listData.length; i++) {
          listData[i].listUserData = [];
          if (listData[i].repPttn !== '' && listData[i].cvtrTpCd.includes('CAPTOR')) {
            let arrPttn = listData[i].repPttn.replace(/"/g, '').split(',');
            listData[i].listUserData = [];
            for (let j = 0; j < arrPttn.length; j += 2) {
              listData[i].listUserData.push({
                id: j / 2,
                key: arrPttn[j],
                value: arrPttn[j + 1],
              });
            }
          }
          if (listData[i].cvtrTpCd === 'DB_CAPTOR') {
            listData[i].dBBroker = listData[i].srcPttn;
          }
        }
        this.listConverter = listData;
        this.formData = Object.assign({}, this.options.item.data);
        if (this.options.item.action == 'Copy') {
          this.formData.cvtrNm = '';
          this.formData.cvtrId = '';
          this.listConverter.forEach((e) => {
            e.oldSeq = '';
            e.flag = 'I';
            e.cvtrId = '';
          });
          this.setFocus();
        }
      } else {
        this.setFocus();
      }
    },
    addCaptor(index) {
      const converter = this.listConverter[index];
      let i =
        converter.listUserData.length > 0
          ? converter.listUserData[converter.listUserData.length - 1].id + 1
          : 1;
      let obj = {
        id: i,
        key: '',
        value: '',
      };
      converter.listUserData.push(obj);
      this.listConverter.splice(index, 1, converter);
    },
    removeCaptor(index, i) {
      const converter = this.listConverter[index];
      converter.flag = 'U';
      converter.listUserData.splice(i, 1);
      this.listConverter.splice(index, 1, converter);
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.cvtrNm.focus();
      }, 300);
    },
    selectConverterType(index) {
      const type = this.listConverter[index].cvtrTpCd;
      const id = this.listConverter[index].cvtrId;
      const seq = this.listConverter[index].seq;
      const flag = this.listConverter[index].flag;
      let converter = Object.assign({}, this.getInitData());
      converter.cvtrTpCd = type;
      converter.cvtrId = id;
      converter.seq = seq;
      converter.flag = flag;
      if (type == 'FILENAME_REPLACER' || type == 'SHINE_CAPTOR') {
        converter.srcPttn = String.raw`.+`;
      } else {
        converter.srcPttn = '';
      }
      if (type == 'FILENAME_REDUCER') {
        converter.nmCutTp = '0';
      } else {
        converter.nmCutTp = '';
      }
      this.listConverter.splice(index, 1, converter);
    },
    getInitData() {
      return {
        cvtrTpCd: '',
        cvtrId: '',
        seq: '',
        srcPttn: '',
        repPttn: '',
        nmMaxLen: '',
        nmCutTp: '',
        skipLineCnt: '',
        reptLineCnt: '',
        envHdr: '',
        envFtr: '',
        spltPttn: '',
        dBBroker: '',
        listUserData: [],
      };
    },
    async onSave() {
      const checkDuplicate = this.validateConverterName();
      if (!checkDuplicate) return;
      let validResult = this.$refs.form.validate();
      if (!validResult) return;
      for (let i = 0; i < this.listConverter.length; i++) {
        if (this.listConverter[i].cvtrTpCd === '') return;
        // FILENAME_REPLACER
        else if (this.listConverter[i].cvtrTpCd === 'FILENAME_REPLACER') {
          if (this.listConverter[i].srcPttn === '') return;
          else if (this.listConverter[i].repPttn === '') return;
        }
        // FILENAME_REDUCER
        else if (this.listConverter[i].cvtrTpCd === 'FILENAME_REDUCER') {
          if (this.listConverter[i].nmMaxLen === '') return;
          else if (this.listConverter[i].nmCutTp === '') return;
        }
        // FILECONTENT_REPLACER
        else if (this.listConverter[i].cvtrTpCd === 'FILECONTENT_REPLACER') {
          if (this.listConverter[i].srcPttn === '') return;
          if (this.listConverter[i].skipLineCnt === '') this.listConverter[i].skipLineCnt = '0';
          if (this.listConverter[i].reptLineCnt === '') this.listConverter[i].reptLineCnt = '0';
        }
        // FILE_ENVELOPER
        else if (this.listConverter[i].cvtrTpCd === 'FILE_ENVELOPER') {
          if (this.listConverter[i].envHdr === '' && this.listConverter[i].envFtr === '') {
            this.add_valid_str = 'Please insert envelope header or envelope footer.';
            this.$refs.warningDialog.dialog = true;
            return;
          }
        }
        // FILE_DEENVELOPER
        else if (this.listConverter[i].cvtrTpCd === 'FILE_DEENVELOPER') {
          if (
            this.listConverter[i].envHdr === '' &&
            this.listConverter[i].envFtr === '' &&
            this.listConverter[i].spltPttn === ''
          ) {
            this.add_valid_str = 'Please insert deenvelope header/footer or split pattern.';
            this.$refs.warningDialog.dialog = true;
            return;
          }
        }
        // FILENAME_CAPTOR
        else if (this.listConverter[i].cvtrTpCd === 'FILENAME_CAPTOR') {
          if (this.listConverter[i].srcPttn === '') return;
          else if (this.listConverter[i].listUserData.length === 0) {
            this.add_valid_str = 'Please insert User Data (at least one)';
            this.$refs.warningDialog.dialog = true;
            return;
          }
        }
        // FILECONTENT_CAPTOR
        else if (this.listConverter[i].cvtrTpCd === 'FILECONTENT_CAPTOR') {
          if (this.listConverter[i].srcPttn === '') return;
          else if (this.listConverter[i].listUserData.length === 0) {
            this.add_valid_str = 'Please insert User Data (at least one)';
            this.$refs.warningDialog.dialog = true;
            return;
          }
          if (this.listConverter[i].skipLineCnt === '') this.listConverter[i].skipLineCnt = '0';
          if (this.listConverter[i].reptLineCnt === '') this.listConverter[i].reptLineCnt = '0';
        }
        // USERDATA_CAPTOR
        else if (this.listConverter[i].cvtrTpCd === 'USERDATA_CAPTOR') {
          if (this.listConverter[i].listUserData.length === 0) {
            this.add_valid_str = 'Please insert User Data (at least one)';
            this.$refs.warningDialog.dialog = true;
            return;
          }
        }
        // API_CAPTOR
        else if (this.listConverter[i].cvtrTpCd === 'API_CAPTOR') {
          if (this.listConverter[i].srcPttn === '') return;
        }
        // DB_CAPTOR
        else if (this.listConverter[i].cvtrTpCd === 'DB_CAPTOR') {
          if (this.listConverter[i].dBBroker === '') return;
        }
        // SHINE_CAPTOR
        else if (this.listConverter[i].cvtrTpCd === 'SHINE_CAPTOR') {
          if (this.listConverter[i].srcPttn === '') return;
          else if (this.listConverter[i].repPttn === '') return;
        }

        if (
          this.listConverter[i].cvtrTpCd.includes('CAPTOR') &&
          this.listConverter[i].cvtrTpCd !== 'SHINE_CAPTOR'
        ) {
          this.listConverter[i].repPttn = '';
          if (this.listConverter[i].listUserData.length > 0) {
            let num = this.listConverter[i].listUserData.findIndex(
              (e) => !e.key.replace(/\s/g, '').length || !e.value.replace(/\s/g, '').length
            );
            if (num > -1) {
              this.hideItem = false;
              let index = this.listConverter[i].listUserData[num];
              return this.$refs[
                `CAPTOR_${i + '_' + index.id}${
                  !index.key.replace(/\s/g, '').length ? '' : '_' + index.id
                }`
              ][0].focus();
            }

            let arrChk = this.listConverter[i].listUserData.map((e) => {
              return e.key + e.value;
            });
            let isDuplicate = arrChk.findIndex((e, i) => {
              return arrChk.indexOf(e) != i;
            });

            if (isDuplicate > -1) {
              this.add_valid_str = 'Duplicate user data.';
              this.$refs.warningDialog.dialog = true;
              return;
            }

            let repPttn = '';
            this.listConverter[i].listUserData.map((e) => {
              repPttn += `"${e.key}","${e.value}",`;
            });

            repPttn = repPttn.slice(0, repPttn.length - 1);
            this.listConverter[i].repPttn = repPttn;
          }
        }

        if (this.listConverter[i].dBBroker) {
          this.listConverter[i].srcPttn = this.listConverter[i].dBBroker;
        }
      }
      showProgress();
      this.formData.listConverter = this.listConverter;
      this.formData.deleteSubList = this.deleteSubList;
      if (this.formData.cvtrId === '' || this.formData.cvtrId === undefined) {
        this.$store
          .dispatch('insertConverterFromProcSetup', this.formData)
          .then(() => {
            hideProgress();
            this.removeDialogRefesh({});
          })
          .catch((ex) => {
            this.add_valid_str = this.$t('msg.converter.errorSave');
            this.$refs.errorDialog.dialog = true;
            hideProgress();
          });
      } else {
        this.$store
          .dispatch('editConverterFromProcSetup', this.formData)
          .then(() => {
            hideProgress();
            this.removeDialogRefesh({});
          })
          .catch((ex) => {
            this.add_valid_str = this.$t('msg.converter.errorSave');
            this.$refs.errorDialog.dialog = true;
            hideProgress();
          });
      }
    },
    removeDialogRefesh(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      this.$emit('refeshList');
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },

  created() {
    this.initialize();
  },

  mounted() {},
};
</script>

<style>
.form-identification .check-btn-partner {
  margin-top: 5px;
  min-width: 20px !important;
}
.check-row-partner {
  height: 22px;
}
.dialogs .dialog-drag.customerEDIInfo .dialog-body {
  padding-top: 0px !important;
  background-color: #3b3e49 !important;
}
.edi-iden-partner-list {
  min-height: 370px;
  max-height: 370px;
  overflow-y: auto;
}
.form-identification {
  margin-bottom: -10px !important;
}
.dialog-body .button-col.action-col.cvtr-custom {
  background-color: #25272e !important;
}
.row-space-user-data {
  margin-bottom: -8px !important;
}
</style>
